<template>
    <v-card>
        <canvas ref="canvas" :width="width" :height="height" style="display: none;"></canvas>

        <s-toolbar label="Fotos de Cumpleaños por Mes" dark color="#8e8f91"></s-toolbar>
        <v-container>
            <v-row>
                <v-col cols="12" md="4">
                    <s-text v-model="Month" label="Mes" placeholder="Prueba"></s-text>
                </v-col>
                <v-col cols="12" md="4">
                    <s-text v-model="Email" label="Email" placeholder="email@example.com"></s-text>
                </v-col>
                <v-col cols="12" md="3" class="d-flex align-end justify-center">
                    <v-btn @click="generateImage" color="success">Generar Imagen&nbsp;<v-icon>mdi-image-sync</v-icon></v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex justify-center">
                    <div v-if="base64Images.length">
                        <div v-for="(img, index) in base64Images" :key="index" style="margin-bottom: 20px;">
                            <img :src="img" style="cursor: pointer;" :alt="'Generated Calendar ' + (index + 1)" :style="{'width': `${width/2}px`, 'height': `${height/2}px`}" @click="downloadImage(img)" />
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex justify-center">
                    <v-btn block color="success" @click="sendBirthday()">Enviar Correo</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
  
<script>
import _sWorkerAllowance from "@/services/HumanResource/WorkerAllowanceService";

export default {
    data() {
        return {
            birthdays: [
                { name: "QUISPE BURNEO, KEVIN BENGGE", area: "PRODUCCION CONGELADO", date: "2025-10-01" },
                { name: "VALQUI CASTAÑEDA, LIDIA RAQUEL", area: "ADM. PERSONAL Y COMPENSACIONES", date: "2025-10-01" },
                { name: "AQUINO GARAGATTI, DIANA ISABEL", area: "COMERCIAL", date: "2025-10-02" },
                { name: "CARBAJAL GONZALES, ALBERTO FRANCISCO", area: "CONTABILIDAD", date: "2025-10-04" },
                { name: "ADANAQUE VIVANCO, ALFREDO MANUEL", area: "ASISTENCIA TECNICA", date: "2025-10-06" },
                { name: "ESPINOZA ENCALADA, INGRID PAMELA", area: "COMERCIO EXTERIOR", date: "2025-10-06" },
                { name: "MENA AREVALO, YENNY IRIS", area: "SEGURIDAD Y SALUD EN EL TRABAJO", date: "2025-10-07" },
                { name: "OVALLE AZABACHE, RICARDO ENRIQUE", area: "ACONDICIONADO CONGELADO", date: "2025-10-07" },
                { name: "BARDALES GUILLERMO, ANGELLO JEANFRANCO", area: "ASISTENCIA TECNICA", date: "2025-10-11" },
                { name: "VALDIVIEZO ARIZOLA, MARTIN ARTURO", area: "ASISTENCIA TECNICA", date: "2025-10-11" },
                { name: "LAZO BACA, SANDRA DEL PILAR", area: "LOGISTICA", date: "2025-10-12" },
                { name: "RETO CANALES, SANDRA EVELYN", area: "RECURSOS HUMANOS", date: "2025-10-13" },
                { name: "MONTERO HERRERA, JORGE EDUARDO", area: "LOGÍSTICA DE OPERACIONES AGRÍCOLAS", date: "2025-10-14" },
                { name: "SILVA ANCAJIMA, EMILIO PIERRE", area: "ASEGURAMIENTO DE LA CALIDAD", date: "2025-10-15" },
                { name: "CASTILLO RAYMUNDO, ELVER", area: "ASISTENCIA TECNICA", date: "2025-10-22" },
                { name: "CAMINO DELLY, JORGE ALBERTO", area: "OPERACIONES AGRICOLAS", date: "2025-10-31" }
            ],
            days: [],
            base64Images: [],
            backgroundImg: null,
            hatImg: null,
            width: 1120,
            height: 630,
            currentMonth : "",

            Month: "",
            Email: "gerencias@sunshineperu.com",
        };
    },
    mounted() {
        this.loadImages();

        const days = [];
        const columns = 7;
        const cellWidth = 97;
        const cellHeight = 73;
        const spacingX = 6;
        const spacingY = 6;
        const offsetX = 72;
        const offsetY = 196;

        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth(); // 0-indexed
        const firstDay = new Date(year, month, 1).getDay(); // Domingo = 0
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        const startOffset = firstDay === 0 ? 6 : firstDay - 1; // Ajuste si el mes empieza en domingo

        for (let i = 0; i < 42; i++) {
            const col = i % columns;
            const row = Math.floor(i / columns);

            const dayNumber = i - startOffset + 1;

            days.push({
                day: dayNumber > 0 && dayNumber <= daysInMonth ? dayNumber : null,
                ejeX: offsetX + col * (cellWidth + spacingX),
                ejeY: offsetY + row * (cellHeight + spacingY),
                width: cellWidth,
                height: cellHeight
            });
        }

        this.days = days;

        this.currentMonth = this.getCurrentMonthName();

        this.Month = this.currentMonth;
    },
    methods: {
        async loadImages() {
            this.backgroundImg = await this.loadImage(require('@/assets/calendar.png'));
            this.hatImg = await this.loadImage(require('@/assets/hat.png'));

            this.generateImage();
        },
        getCurrentMonthName() {
            const months = [
                'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ];
            const today = new Date();
            return months[today.getMonth()];
        },
        loadImage(src) {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(img);
                img.src = src;
            });
        },
    
        async generateImage() {
            const scaleFactor = 3;
            const width = this.width;
            const height = this.height;
            const canvas = this.$refs.canvas;
            const ctx = canvas.getContext("2d");

            canvas.width = width * scaleFactor;
            canvas.height = height * scaleFactor;
            canvas.style.width = width + 'px';
            canvas.style.height = height + 'px';
            ctx.scale(scaleFactor, scaleFactor);

            await document.fonts.load('62px "Mistrully"');
            await document.fonts.ready;
            await document.fonts.load('16px "CooperLtBT-Regular"');
            ctx.clearRect(0, 0, width, height);

            // Agrupar cumpleaños por día
            const birthdaysByDay = {};
            this.birthdays.forEach(item => {
                const day = parseInt(item.date.split("-")[2]);
                if (!birthdaysByDay[day]) birthdaysByDay[day] = [];
                birthdaysByDay[day].push(item.name);
            });

            // Aplanar lista y agrupar por bloques de 17
            const allNames = [];
            Object.keys(birthdaysByDay).sort((a, b) => a - b).forEach(day => {
                birthdaysByDay[day].forEach(name => {
                allNames.push({ day, name });
                });
            });

            // Agrupar en bloques de 17 nombres
            const blocks = [];
            const blockSize = 16;
            for (let i = 0; i < allNames.length; i += blockSize) {
                blocks.push(allNames.slice(i, i + blockSize));
            }

            this.base64Images = [];

            for (const block of blocks) {
                ctx.clearRect(0, 0, width, height);
                ctx.drawImage(this.backgroundImg, 0, 0, width, height);

                // Título
                ctx.font = "62px Mistrully";
                ctx.fillStyle = "#6E9628";
                ctx.textAlign = "center";
                ctx.textBaseline = "top";
                ctx.fillText(this.currentMonth, 625, 80);
                ctx.textBaseline = "bottom";

                // Dibujar gorros
                this.days.forEach(day => {
                    // Dibujar número del día en esquina superior derecha si existe
                    if (day.day !== null) {
                        ctx.font = "12px CooperLtBT-Regular";
                        ctx.fillStyle = "#000000";
                        ctx.textAlign = "left";
                        ctx.fillText(day.day.toString().padStart(2, '0'), day.ejeX + 5, day.ejeY + 16);

                        // Dibujar gorro si hay cumpleaños
                        const celebrants = birthdaysByDay[day.day];
                        if (celebrants) {
                            const centerX = day.ejeX + day.width / 2;
                            const centerY = day.ejeY + day.height / 2;
                            const size = 50;

                            ctx.drawImage(this.hatImg, centerX - size / 2, centerY - size / 2, size, size);
                            ctx.fillStyle = "#1A1A1A";
                            ctx.font = "bold 14px CooperLtBT-Regular";
                            ctx.textAlign = "center";
                            ctx.fillText(celebrants.length.toString(), centerX, centerY + 15);
                        }
                    }
                });

                // Dibujar lista de nombres de este bloque
                ctx.font = "15px CooperLtBT-Regular";
                ctx.fillStyle = "black";
                ctx.textAlign = "start";
                let startY = 155;
                const startX = 815;
                block.forEach(item => {
                    const dayFormatted = String(item.day).padStart(2, '0');
                    const nameFormatted = item.name
                        .toLowerCase()
                        .split(' ')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ');
                    ctx.fillText(`${dayFormatted} - ${nameFormatted}`, startX, startY);
                    startY += 30;
                });

                const imgBase64 = canvas.toDataURL("image/png", 1.0);
                this.base64Images.push(imgBase64);
            }
        },
        sendBirthday() {
            if(!this.base64Images){
                return this.$fun.alert("No se encuentra la imagen", "warning");
            }
            if(!this.Month || !this.Email){
                return this.$fun.alert("Todos los campos son obligatorios", "warning");
            }
            // const obj = {
            //     Month: this.Month,
            //     Email: this.Email,
            //     ImgSrc: this.base64Images
            // }
            const formData = new FormData();
            formData.append("Month", this.Month);
            formData.append("Email", this.Email);

            // Suponiendo que tienes los blobs o files en un array:
            this.base64Images.forEach((b64, index) => {
                const byteString = atob(b64.split(',')[1]);
                const arrayBuffer = new Uint8Array(byteString.length);
                for (let i = 0; i < byteString.length; i++) {
                    arrayBuffer[i] = byteString.charCodeAt(i);
                }
                const blob = new Blob([arrayBuffer], { type: 'image/png' });
                formData.append("Images", blob, `image${index}.png`);
            });

            // console.log(obj);
            this.$fun.alertFull("¿Seguro de enviar?", "question")
				.then(r => {
					if (r.value) {
                        _sWorkerAllowance.sendBirthdayMonth(formData, this.$fun.getUserID()).then((r) => {
                            if (r.status == 200) {
                                console.log(r);
                                this.$fun.alert("Correo Enviado", "success");
                            }
                        })
                    }
            });
        },
        downloadImage(img) {
            if (img) {
                const link = document.createElement('a');
                link.href = img;
                link.download = 'birthday_image.jpeg';
                link.click();
            }
        }
    }
};
</script>